module.exports = __webpack_public_path__ + "assets/img/behavior.fde16bb9.svg";